import React, { useEffect, useState } from 'react';
// import { Col, Row } from 'shards-react';
import classNames from 'classnames';
import RoleAlert from './RoleAlert';
import TradingCompanyInformation from './TradingCompanyInformation';
// import LanguageSelector from '../../common/LanguageSelector';

interface MainNavbarProps {
  layout?: string;
  stickyTop?: boolean;
}
const MainNavbar = ({ layout, stickyTop }: MainNavbarProps): React.ReactElement => {
  const classes = classNames('main-navbar', 'bg-white', stickyTop && 'sticky-top');

  // SIDE EFFECT
  // ================================================================================

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <div id="mainNavBar" className={classes}>
      <RoleAlert />
      <TradingCompanyInformation />
      {/* <Row className="px-3 py-2">
        <Col className="d-flex justify-content-end">
          <LanguageSelector />
        </Col>
      </Row> */}
    </div>
  );
};

export default MainNavbar;
